import { render } from "./SinglePost.vue?vue&type=template&id=4bcdbf02&scoped=true"
import script from "./SinglePost.vue?vue&type=script&lang=js"
export * from "./SinglePost.vue?vue&type=script&lang=js"

import "./SinglePost.vue?vue&type=style&index=0&id=4bcdbf02&scoped=true&lang=scss"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcdbf02"]])

export default __exports__